import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import ProjectCard from "@/components/ProjectCard";
import { useContent } from "@/context/ContentContext";

export default function Projects() {
    const content = useContent();
    const [filter, setFilter] = useState("All");
    const FILTERS = [
        "All",
        ...new Set(content.projects.map((p) => p.category).filter(Boolean)),
    ];
    const visible =
        filter === "All"
            ? content.projects
            : content.projects.filter((p) => p.category === filter);

    return (
        <>
            <PageHeader
                crumb="HOME / PROJECTS"
                eyebrow="02 — SELECTED WORK"
                lines={["PROJECTS"]}
                sub="Things I've built, shipped and studied."
            />
            <section className="px-5 lg:px-12 xl:px-16 py-14 lg:py-20 pb-24">
                <Reveal className="flex flex-wrap gap-3">
                    {FILTERS.map((f) => (
                        <button
                            key={f}
                            data-testid={`filter-chip-${f
                                .toLowerCase()
                                .replace(/\s+/g, "-")}`}
                            onClick={() => setFilter(f)}
                            className={`mono text-[11px] tracking-[0.2em] uppercase border px-4 py-2 rounded-full transition-colors duration-300 ${
                                filter === f
                                    ? "bg-ink text-paper border-ink"
                                    : "border-line text-muted2 hover:border-ink hover:text-ink"
                            }`}
                        >
                            {f}
                        </button>
                    ))}
                </Reveal>

                <motion.div
                    layout
                    className="mt-12 grid gap-8 sm:grid-cols-2 xl:grid-cols-3"
                    data-testid="projects-grid"
                >
                    <AnimatePresence mode="popLayout">
                        {visible.map((p, i) => (
                            <motion.div
                                key={p.slug}
                                layout
                                initial={{ opacity: 0, y: 24 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, scale: 0.97 }}
                                transition={{
                                    duration: 0.45,
                                    ease: [0.22, 1, 0.36, 1],
                                    delay: i * 0.05,
                                }}
                            >
                                <ProjectCard project={p} i={i} />
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </motion.div>

                {visible.length === 0 && (
                    <p
                        className="mono text-sm text-muted2 mt-10"
                        data-testid="projects-empty-state"
                    >
                        Nothing here yet — more coming soon.
                    </p>
                )}
            </section>
        </>
    );
}
